import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

interface IConfirmDialogDelete {
  visibility: boolean;
  // eslint-disable-next-line no-unused-vars
  setVisibility: (arg: boolean) => void;
  accept: () => void;
  reject: () => void;
  message: string;
}
export const ConfirmDialogDelete = ({
  visibility,
  setVisibility,
  message,
  accept,
  reject,
}: IConfirmDialogDelete) => {
  return (
    <Dialog
      dismissableMask
      header={'Предупреждение'}
      visible={visibility}
      className="p-confirm-dialog"
      footer={
        <>
          <Button autoFocus label="Да" data-at-wc-confirm-dialog-delete-accept onClick={accept} />
          <Button label="Нет" data-at-wc-confirm-dialog-delete-reject onClick={reject} text />
        </>
      }
      onHide={() => setVisibility(false)}
    >
      <span
        className="p-confirm-dialog-icon pi pi-exclamation-triangle"
        data-pc-section="icon"
      ></span>
      <span className="p-confirm-dialog-message" data-pc-section="message">
        {message}
      </span>
    </Dialog>
  );
};
